// @ts-nocheck
import {
  Box,
  Button,
  CircularProgress,
  InputLabel,
  Modal,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  closeReportModalAction,
  reportContractorAction,
  restrictContractorAction,
} from "../../store/actions/sms/sms";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { CustomTextFiled } from "../Custom/Input";
import { alertDialogAciton } from "../../store/actions/auth";

const style = {
  boxShadow: 24,
  p: 4,
  pb: 0,
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  width: "500px",
  maxHeight: "90vh",
  maxWidth: "1000px",
  overflowY: "auto",
  "@media (max-width: 600px)": {
    maxHeight: "97vh",
    maxWidth: "95vh",
  },
};

export const ReportModal = () => {
  const {
    reportModalStatus,
    reportLoading: isLoading,
    reportUser,
  } = useSelector((state) => state?.smsReducer);
  const dispatch = useDispatch();

  const initialValues = useMemo(() => {
    return {
      message: reportUser?.remark || "",
    };
  }, [reportUser?.remark]);

  function onClose() {
    dispatch(closeReportModalAction());
    formik.resetForm();
  }

  const validationSchema = Yup.object().shape({
    message: Yup.string()
      .trim()
      .required("There should be some message.")
      .max(1000, "The message should be at most 1000 characters."),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      // api to report this contractor
      const data = {
        remark: values?.message,
      };
      const params = {
        contractorId: reportUser?._id,
      };

      const payload = {
        data,
        params,
      };

      const successCallback = (msg) => {
        if (reportUser?.successCallback) {
          reportUser?.successCallback();
        }
        resetForm();
        dispatch(closeReportModalAction());
        dispatch(
          alertDialogAciton({
            open: true,
            title: "Success",
            message:
              msg ||
              (reportUser?.isRestrictPopup
                ? "Contractor have been restricted."
                : "Contractor have been flagged."),
          }),
        );
      };

      const failureCallback = (msg) => {
        dispatch(
          alertDialogAciton({
            open: true,
            title: "Failure",
            message:
              msg ||
              (reportUser?.isRestrictPopup
                ? "Failed to restrict contractor"
                : "Failed to flag contractor."),
          }),
        );
      };

      if (reportUser?.isRestrictPopup) {
        dispatch(
          restrictContractorAction({
            payload,
            successCallback,
            failureCallback,
          }),
        );
      } else {
        dispatch(
          reportContractorAction({
            payload,
            successCallback,
            failureCallback,
          }),
        );
      }
    },
  });

  const { values, handleChange, handleBlur, touched, submitForm, errors } =
    formik;

  const buttonName = useMemo(() => {
    const titleName = reportUser?.title?.trim()?.toLowerCase();
    if (titleName == "restrict contractor") {
      return "Restrict";
    } else if (titleName == "flag contractor" || !titleName) {
      return "Flag";
    }

    return "Save";
  }, [reportUser?.title]);

  return (
    <Modal
      open={reportModalStatus}
      onClose={onClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          ...style,
          display: "flex",
          justifyContent: "flex-start",
          aliginItems: "flex-start",
          gap: "1rem",
          flexDirection: "column",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "1.25rem",
              paddingBottom: "1rem",
            }}
          >
            {reportUser?.title || "Flag Contractor"}
          </Typography>

          <Typography
            sx={{
              "& p": {
                display: "inline-flex",
              },
            }}
          >
            <Typography
              sx={{
                color: getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                }),
              }}
            >
              Name:
            </Typography>{" "}
            <Typography>
              {reportUser?.preferredName || reportUser?.name}
            </Typography>
          </Typography>

          <Box mt={2}>
            <InputLabel>Remark:</InputLabel>
            <CustomTextFiled
              sx={{
                height: "auto !important",
              }}
              fullWidth
              name="message"
              onBlur={handleBlur}
              onChange={handleChange}
              placeholder={"Write your message here"}
              multiline
              value={values?.message}
              rows={3}
            />
            {errors?.message && touched?.message && (
              <Typography color="red">{errors?.message}</Typography>
            )}
          </Box>

          <Box
            className="bottom-btn-box"
            sx={{
              width: "100%",
              marginTop: "2rem",
              alignSelf: "flex-end",
              marginBottom: " 2rem",
            }}
          >
            <Button
              className="btn-black"
              sx={{
                width: "50%",
                height: "3.25rem",
                textTransform: "none !important",
              }}
              onClick={onClose}
            >
              <Typography className="btn-text">Close</Typography>
            </Button>

            <Button
              className="btn-pink"
              sx={{
                width: "50%",
                height: "3.25rem",
                textTransform: "none !important",
                "&:disabled": {
                  background: "#d85ad8 !important",
                },
              }}
              onClick={submitForm}
            >
              {isLoading ? (
                <CircularProgress size={22} />
              ) : (
                <Typography sx={{ whiteSpace: "nowrap" }} className="btn-text">
                  {buttonName}
                </Typography>
              )}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

ReportModal.propTypes = {};